export { default } from "./linkingConfig";
